<template>
<div>   
    <link rel="stylesheet" href="https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css" integrity="sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N" crossorigin="anonymous">
		<meta name="viewport" content="width=device-width, initial-scale=1, shrink-to-fit=no">
		
		<div class=" col-md-6 col-12 p-0">

			<div class="col-12 row mx-0 px-3 py-2" style="background-image: linear-gradient(rgb(0, 145, 165), rgb(1, 136, 154), rgb(2, 126, 144), rgb(3, 117, 133), rgb(3, 108, 123));color:#ffffff;">
				<h3><strong>{{msglist[$route.params.language][1]}}: {{uname}}</strong></h3>
				<div class="ml-auto"><router-link :to="{ name: 'my-kh', params: { language: $route.params.language }}">
          			<button class="btn btn-primary" style="font-size: 15px; border-radius: 5px;">{{msglist[$route.params.language][30]}}</button><!--KH 設定-->
          		</router-link></div>
			</div>
      
      <strong><div v-bind:class="alertObject"> {{message}} </div></strong>
 
      <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
		  		<div class="col-12 px-0 row mx-0">
		  				 <div class="col border-left align-self-center">
				  			<div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][2]}}<!--e-mail-->
                   <span style="font-weight: normal"> {{msglist[$route.params.language][3]}}</span> <!--(異常通知)-->
                </div>
                <div class="px-0 row mx-0 mb-2 align-self-center">
                      <input style="height:30px;font-size:1.2rem; font-weight: bold" v-model="email_new" type="email" class="form-control" id="email"> 
                </div>
                <div class="col-12 px-0 text-center">
                      <button @click="applyChange" :disabled="disabled" class="btn btn-primary" style="min-width: 150px;">{{msglist[$route.params.language][8]}}</button>
                      <button v-if="uname === 'default'" style="background-color:#ffc105;border:none" @click="delMail" :disable="disabled" class="btn btn-primary">Del</button>  <!--刪除email-->
                </div>
		  				</div>  
		  		  </div>
		 </div>     

     <div class="col-12 row mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
        <div class="col-12 px-0 row mx-0">
            <div class="col border-left align-self-center">
                <div class="col-12 px-0 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][4]}}</div><!--password-->
                
                <div class="row px-0 mx-0">{{msglist[$route.params.language][5]}} 
                  <div class="col px-2 mx-0 mb-2 align-self-center">
                      <input style="height:30px;font-size:1.2rem; font-weight: bold" v-model="currentPassword" type="text" class="form-control">
                  </div>  
                </div>
                
                <div class="row px-0 mx-0">{{msglist[$route.params.language][6]}}
                  <div class="col px-2  mx-0 mb-2 align-self-center">
                      <input style="height:30px;font-size:1.2rem; font-weight: bold" v-model="newPassword" type="text" class="form-control" >
                  </div> 
                </div>
              
                <div class="row px-0 mx-0">{{msglist[$route.params.language][7]}}
                  <div class="col px-2  mx-0 mb-2 align-self-center">
                      <input style="height:30px;font-size:1.2rem; font-weight: bold" v-model="newPassword1" type="text" class="form-control">
                  </div>  
                </div>
                
                <div class="col-12 px-0 text-center">
                    <button @click="applyChange" :disabled="disabled" class="btn btn-primary" style="min-width: 150px;">{{msglist[$route.params.language][8]}}</button>
                </div>  
            </div>
         </div>
		  </div>    
    
      <div class="col mx-0 px-0 py-2 mb-1" style="background: rgb(242, 242, 242);">
          <div class="col px-3 font-weight-bold" style="font-size:1.2rem">{{msglist[$route.params.language][11]}}</div><!--增刪設備-->
          <div class="row px-3 mx-0">{{msglist[$route.params.language][31]}} 
            <div class="col px-2 mx-0 mb-2 align-self-center">
                <input style="height:30px;font-size:1.2rem; font-weight: bold" v-model="newSerial" type="text" class="form-control">
            </div>  
          </div>
          
          <div class="row px-3 mx-0">{{msglist[$route.params.language][32]}}
            <div class="col px-2  mx-0 mb-2 align-self-center">
                <input style="height:30px;font-size:1.2rem; font-weight: bold" v-model="newPassCode" type="text" class="form-control" >
            </div> 
          </div>

          <div class="row px-3 mx-0">{{msglist[$route.params.language][33]}}
            <div class="col px-2  mx-0 mb-2 align-self-center">
                <input style="height:30px;font-size:1.2rem; font-weight: bold" maxlength="20" v-model="newDevname" type="text" class="form-control" >
            </div> 
          </div>
          
          <div class="col-12 px-0 text-center">
              <button @click="addDevice" :disabled="disabled" class="btn btn-primary">{{msglist[$route.params.language][12]}}</button> <!--新增設備-->
              <button @click="updDevname" :disabled="disabled" class="btn btn-primary">{{msglist[$route.params.language][34]}}</button> <!--設備名稱-->
              <button @click="delDevice"  class="btn btn-primary">{{msglist[$route.params.language][21]}}</button> <!-- 刪除設備-->  
            <div v-if="uname === 'default'" class="col-12 px-0 mt-2 text-center">
              <button style="background-color:#ffc105;border:none" @click="resetPcode" :disable="disabled" class="btn btn-primary">Pcd</button>  <!--重設設備密碼-->
              <!--<button style="background-color:#ffc105;border:none" @click="resetPcode_test" :disable="disabled" class="btn btn-primary">Tst</button>  測試模式-->
              <button style="background-color:#ffc105;border:none" @click="resetDevice" :disable="disabled" class="btn btn-primary">Rst</button> <!--重設設備-->
              <button style="background-color:#ffc105;border:none" @click="insertDevice" :disable="disabled" class="btn btn-primary">Add</button>  <!--插入設備-->
              <button style="background-color:#ffc105;border:none" @click="delDbDevice" :disable="disabled" class="btn btn-primary">Del</button>  <!--刪除DB設備-->
            </div>
          </div> 
		  </div>   

       
      <div class="col mx-0 px-0 py-2 mb-1 text-center" style="background: rgb(242, 242, 242);">
        <router-link :to="{ name: 'entry', params: { language: 'en' }}">  
          <button @click="loggingOut" class="btn btn-primary" style="min-width: 100px" >{{msglist[$route.params.language][10]}}</button><!-- 登出-->  
        </router-link>
          <button @click="delAcount" class="btn btn-primary" style="min-width: 100px">{{msglist[$route.params.language][19]}}</button> <!-- 刪除帳號-->  
      </div>
    
      <div v-if="uname === 'default'" class="col mx-0 px-3 py-2 mb-1" style="background: rgb(242, 242, 242);">
          <div class="col px-0 font-weight-bold" style="font-size:1.2rem">增刪改多個設備資料庫</div>
          <div class="col-12 px-0 mb-2 text-center">
            <button style="background-color:#ffc105;border:none" @click="resetPcode_G" :disable="disabled" class="btn btn-primary">Pcd</button>  <!--重設啟動碼-->
            <!--<button style="background-color:#ffc105;border:none" @click="resetPcode_test_G" :disable="disabled" class="btn btn-primary">Tst</button> 測試模式-->
            <button style="background-color:#ffc105;border:none" @click="update_ver_G" :disable="disabled" class="btn btn-primary">Upd</button>  <!--設定版本-->
            <button style="background-color:#ffc105;border:none" @click="resetDevice_G" :disable="disabled" class="btn btn-primary">Rst</button>  <!--重設設備-->
            <button style="background-color:#ffc105;border:none" @click="insertDevice_G" :disable="disabled" class="btn btn-primary">Add</button>  <!--插入DB設備-->
            <button style="background-color:#ffc105;border:none" @click="delDbDevice_G" :disable="disabled" class="btn btn-primary">Del</button>  <!--刪除DB設備-->
          </div>
          <textarea v-model="newSerial_G" class="col mx-0 px-1 form-control" rows="10" placeholder="序號(tab)啟動碼(tab)版本(\n)
KH1-00-00001 abcd 40117

Pcd - 重設KHA密碼
Upd - 更新KHA韌體版本
Rst - 重設網站設定 清除數據
Add - 新增KHA到資料庫
Del - 從資料庫刪除KHA ">
          </textarea>     
      </div> 
      <div v-if="uname === '123'" class="col mx-0 px-3 py-2 mb-1" style="background: rgb(242, 242, 242);">
          <div class="col px-0 font-weight-bold" style="font-size:1.2rem">修改設備資料庫</div>
          <div class="col-12 px-0 mb-2 text-center">
            <button style="background-color:#ffc105;border:none" @click="resetPcode_G" :disable="disabled" class="btn btn-primary">Pcd</button>  <!--重設啟動碼-->
            <button style="background-color:#ffc105;border:none" @click="update_ver_G" :disable="disabled" class="btn btn-primary">Upd</button>  <!--設定版本-->
          </div>
          <textarea v-model="newSerial_G" class="col mx-0 px-1 form-control" rows="10" placeholder="序號(tab)啟動碼(tab)版本(\n)
KH1-00-00001 abcd 40117

Pcd - 重設KHA密碼
Upd - 更新KHA韌體版本
">
          </textarea>     
      </div> 
    </div>  
</div>
</template>

<script>
//import Log from 'loglevel';
//import has from 'lodash/has';
import {
	mapLang
} from "../routes.js";

const mlist = {
	'en': [
		'Applied','User','E-mail',' (for notification)', 
    'Change Password','Old Password','New Password','Confirm Password','Change','Profile not changed',
    'Log out','Add / Delete / Mod device','Add device ','Error','This device already registered','Wrong Passcode',
    'Wrong Password','Please input password ','Deleted','Delete Account ',
    'Device not owned by user','Delete device ','Only one device owned, please delete account',
    'Delete all data of this device?','No input','Device not found','someone own this device, cannot be deleted','No one own this device, not deleted',
    'Passcode reset ','Device owned by others','My KH',
    'Device serial#','Passcode','Name','Change Name'],
  'vi': [
    'Đã Áp Dụng','Tài Khoản','E-mail',' (để thông báo)', 
    'Đổi mật khẩu','Mật khẩu cũ','Mật khẩu mới','Xác nhận mật khẩu','Thay đổi','Hồ sơ không thay đổi',
    'Đăng xuất','Thêm / Xóa / Mod thiết bị','Thêm thiết bị ','Lỗi','Thiết bị này đã được đăng ký','Mật mã sai',
    'Sai mật khẩu','Vui lòng nhập mật khẩu ','Đã xóa','Xóa tài khoản ',
    'Thiết bị không thuộc sở hữu của người dùng','Xóa thiết bị ','Chỉ sở hữu một thiết bị, vui lòng xóa tài khoản',
    'Xóa tất cả dữ liệu của thiết bị này?','Không có đầu vào','Không tìm thấy thiết bị','ai đó sở hữu thiết bị này, không thể xóa','Không ai sở hữu thiết bị này, không bị xóa',
    'Đặt lại mật mã','Thiết bị thuộc sở hữu của người khác','KH của tôi',
    'Device serial#','Mật mã','Tên','Đổi tên'],
  'ms': [
		'Applied','User','E-mail',' (for notification)', 
    'Change Password','Old Password','New Password','Confirm Password','Change','Profile not changed',
    'Log out','Add / Delete / Mod device','Add device ','Error','This device already registered','Wrong Passcode',
    'Wrong Password','Please input password ','Deleted','Delete Account ',
    'Device not owned by user','Delete device ','Only one device owned, please delete account',
    'Delete all data of this device?','No input','Device not found','someone own this device, cannot be deleted','No one own this device, not deleted',
    'Passcode reset ','Device owned by others','My KH',
    'Device serial#','Passcode','Name','Change Name'],
	'tw': [
		'已更改','會員','電子郵件', ' (異常通知)',   //3
		'更改密碼','舊密碼',	'新密碼','確認新密碼','更改','資料沒變更', //9
    '登出','增刪修設備','新增設備 ','錯誤','已有此會員帳號，請改其他名稱','啟動碼錯誤', //15
    '會員密碼錯誤','請輸入密碼 ','已刪除 ','刪除會員 ',  //19
    '會員無此設備','刪除設備 ','僅剩一個設備，請刪除會員',  //22
    '要刪除此設備的所有資料嗎?','沒輸入','無此設備','設備有主，不可刪除','設備無主，無法刪除', //27
    '重設啟動碼 ','產品序號已被註冊過，不可重複註冊','我的KH', //30
    '設備序號','啟動碼','名稱','修改名稱'],  
	'cn': [
		'已更改','用户','电子邮件',' (异常通知)',
		'更改密码','旧密码','新密码','确认新密码','更改','资料沒更改',
    '登出','增刪修设备','新增设备 ','错误','已有此会员帐号，请改其他名称','启动码错误',
    '用户密码错误','请输入密码 ','已删除 ','删除用户 ',
    '用户无此设备','刪除设备 ','仅剩一个设备，请删除用户',
    '要删除此设备的所有资料吗?','沒輸入','无此设备','设备有主，不可删除','设备无主，无法删除',
    '重设启动码 ','产品序号已被登记过，不可重複注册','我的KH',
    '设备序号','启动码','名称','修改名称'],
}

//let PURL = process.env.SERVER;

function changePw(Vue) {
  let PURL = localStorage.getItem("server") || process.env.SERVER;
  let url = PURL + '/api/v1/db/change/password';
  let body = {
    "user": Vue.uname,
    "password": Vue.currentPassword,
    "newPassword": Vue.newPassword
  };

  //console.log('server: ', PURL, process.env);
  //console.log('url: change: ', url, body, Vue.$store.user);
  // asynch call
  let p1 = Vue.$http.post(url, body);
  Promise.all([p1]).then(([r1]) => {
    console.log("change: ", r1);
    Vue.setMsg_mykh('updated', 5); 
  }, reason => {
      console.log('server error: ', reason);
      Vue.setMsg_mykh("invalid password", 5);
  });
}

function RegDevice(Vue) {   //  addDevice()
  let user = JSON.parse(localStorage.getItem("user")) || Vue.$store.getters.user || {}; 
  let PURL = localStorage.getItem("server") || process.env.SERVER;
  let url = PURL + '/api/v1/KH/register-device';
  let body = {
    "user": Vue.uname,
    "password": Vue.currentPassword,
    "serial": Vue.newSerial,
    "passcode": Vue.newPassCode,
  };

  if (Vue.newSerial === null || Vue.newSerial === "") {
    Vue.message = mlist[Vue.getLang()][24]; // no input
    Vue.setMsg(Vue.message, 5); return;} // show message 
  
  let p1 = Vue.$http.post(url, body);
  Promise.all([p1]).then(([r1]) => {
    //console.log("change: ", r1);
    console.log("Success to add device");
    ////////// add device in localstorage user.data.devices //////
    Vue.$set(user.data.devices, user.data.devices.length, Vue.newSerial); 
    localStorage.setItem('user', JSON.stringify(user));

    Vue.setMsg_mykh(mlist[Vue.getLang()][12] + Vue.newSerial, 5); // show message add device

  }, reason => {
      let rea=JSON.stringify(reason) ; 
      //console.log('server error: ', reason);
      if (rea.match(/already owned by others/gi)) {
            Vue.message=mlist[Vue.getLang()][29];}
      if (rea.match(/already registered/gi)) {
            Vue.message=mlist[Vue.getLang()][14];}
      if (rea.match(/wrong passcode/gi)) {
            Vue.message=mlist[Vue.getLang()][15];}
      if (rea.match(/device not found/gi)) {
            Vue.message=mlist[Vue.getLang()][25];}
      Vue.setMsg(Vue.message, 5); // show message only
  });
}
function Set_Dev_name(Vue) {
  let PURL = localStorage.getItem("server") || process.env.SERVER;
  let url = PURL + '/api/v1/KH/upd_dev_name';
  let body = {
    "user": Vue.uname,
    "password": Vue.currentPassword,
    "serial": Vue.newSerial,
    "dev_name": Vue.newDevname,
  };
  
  if (Vue.newSerial === null || Vue.newSerial === "" || Vue.newDevname === null || Vue.newDevname === "") {
    Vue.message = mlist[Vue.getLang()][24];
    Vue.setMsg(Vue.message, 5); return;// show message
  }
  let p1 = Vue.$http.post(url, body);
  Promise.all([p1]).then(([r1]) => {
    //console.log("change: ", r1);
    console.log("Success to update device name", Vue.newSerial, " name ", Vue.newDevname);
    Vue.message = Vue.newSerial + mlist[Vue.getLang()][34] + " " + Vue.newDevname;
    Vue.setMsg(Vue.message, 5); // show message
  }, reason => {
      let rea=JSON.stringify(reason) ;   
      console.log('server error: ', reason.body);
      if (rea.match(/device not found/gi)) {
            Vue.message=mlist[Vue.getLang()][25];}
      if (rea.match(/not owned/gi)) {
            Vue.message=mlist[Vue.getLang()][20];}
      Vue.setMsg(Vue.message, 5); // show message only
  });
}
function InsDevice(Vue) {
  let PURL = process.env.SERVER;
  let url = PURL + '/api/v1/KH/insert-db-device';
  let body = {
    "serial": Vue.newSerial,
    "passcode": Vue.newPassCode
  };

  if (Vue.newSerial === null || Vue.newSerial === "" || Vue.newPassCode === null || Vue.newPassCode === "") {
    Vue.message = mlist[Vue.getLang()][24]; // no input
    Vue.setMsg(Vue.message, 5); return;// show message sec only
  }
  //console.log("body: ", body);
  let p1 = Vue.$http.post(url, body);
  Promise.all([p1]).then(([r1]) => {
    //console.log("change: ", r1);
    console.log("Success to insert device", Vue.newSerial);
    Vue.setMsg(mlist[Vue.getLang()][12] + Vue.newSerial, 5); // show message add device
  }, reason => {
      let rea=JSON.stringify(reason) ; 
      console.log('server error: ', reason);
      if (rea.match(/serial duplicated/gi)) {
            Vue.message=mlist[Vue.getLang()][14];}
      Vue.setMsg(Vue.message, 5); // show message only 
  });
}

function InsDevice_G(Vue) {     // insert a group of devices to DB
  let Serial_Pass_array = Vue.newSerial_G.split('\n');  // get 'KH1-00-00123, abcd' string
  for(let i = 0; i < Serial_Pass_array.length; i++) {
      Vue.newSerial = Serial_Pass_array[i].split('\t')[0];
      Vue.newPassCode = Serial_Pass_array[i].split('\t')[1]; 
  
      console.log(Serial_Pass_array[i], 'Serial ', Vue.newSerial,  'Pass ', Vue.newPassCode );
      InsDevice(Vue);
  } // for i
}

function isValidEmail(email) {
    const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return regex.test(email);
}

function changeInfo(Vue) {
  let user = JSON.parse(localStorage.getItem("user")) || Vue.$store.getters.user || {};   
  let anyUpdate = false; // record any changed and need to be updated
  let PURL = localStorage.getItem("server") || process.env.SERVER;
  let url = PURL + '/api/v1/db/change/user_info';
  let body = {
              "user": Vue.uname
             };
  // if supplied old password, the new password will take effect
  //if (Vue.newPassword === Vue.newPassword1 && Vue.newPassword !== "") {
  if (Vue.newPassword === Vue.newPassword1 && Vue.newPassword !== Vue.currentPassword) {
    body["password"] = Vue.currentPassword;
    body["newPassword"] = Vue.newPassword;
    anyUpdate = true;
  } else {
    body["password"] = "";
  }
  if (Vue.email !==Vue.email_new) {
    console.log('email different old, new:', Vue.email, Vue.email_new);
    if (Vue.email_new == '' || (Vue.email_new !== '' && isValidEmail(Vue.email_new))) {
      body["email"] = Vue.email_new;
      Vue.email=Vue.email_new;
      user.data.email = body["email"]; // update local storage
      anyUpdate = true;
    } else {
      console.log('check email fail');
      Vue.email_new=Vue.email; // check email format
      anyUpdate=false;
    }
  }
  if (Vue.mobile !==Vue.mobile_new) {
    body["mobile"] = Vue.mobile_new;
    user.data.mobile = body["mobile"]; // update local storage
    anyUpdate = true;
  }
  if (Vue.line !==Vue.line_new) {
    body["line"] = Vue.line_new;
    user.data.line = body["line"]; // update local storage
    anyUpdate = true;
  }
  if (Vue.wechat !==Vue.wechat_new) {
    body["wechat"] = Vue.wechat_new;
    user.data.wechat = body["wechat"]; // update local storage
    anyUpdate = true;
  }
  if (Vue.whatsapp !==Vue.whatsapp_new) {
    body["whatsapp"] = Vue.whatsapp_new;
    user.data.whatsapp = body["whatsapp"]; // update local storage
    anyUpdate = true;
  }
  
  if (anyUpdate) {
    /////// update parameters in localstorage ////////
    localStorage.setItem('user', JSON.stringify(user));
    ////// update parameters in server /////////
    // asynch call
    let p1 = Vue.$http.post(url, body);
    Promise.all([p1]).then(([r1]) => {
      //console.log("change: ", r1);
      Vue.setMsg_mykh(mlist[Vue.getLang()][0], 5);  //已更改 and back to my-kh
  }, reason => {
    let rea=JSON.stringify(reason) ; 
    console.log('server error: ', reason.body);
    if (rea.match(/wrong password/gi)) {
        Vue.message=mlist[Vue.getLang()][16]; }
    else {Vue.message=mlist[Vue.getLang()][13];}
      Vue.setMsg_logout(Vue.message, 5);  // setMsg_logout: show message and logout
  });

  } else { // if anyUpdate
    Vue.setMsg(mlist[Vue.getLang()][9], 5); //資料沒變更 
  }
}

function deletemail(Vue) {
  let user = JSON.parse(localStorage.getItem("user")) || Vue.$store.getters.user || {};   
  let anyUpdate = false; // record any changed and need to be updated
  let PURL = process.env.SERVER;  // allow aws only
  let url = PURL + '/api/v1/db/delete/user_email';
  let body = {
              "user": Vue.uname
             };
  if (Vue.email_new !=='' && Vue.email_new.includes('@')) {   //check email format
      body["email"] = Vue.email_new; // email to be deleted
      anyUpdate = true;
  }
  
  if (anyUpdate) {
    ////// update parameters in server /////////
  // asynch call
  let p1 = Vue.$http.post(url, body);
  Promise.all([p1]).then(([r1]) => {
    //console.log("change: ", r1);
      Vue.setMsg_mykh(mlist[Vue.getLang()][0], 5);  //已更改 and back to my-kh
  }, reason => {
    let rea=JSON.stringify(reason) ; 
    console.log('server error: ', reason.body);
    if (rea.match(/wrong password/gi)) {
        Vue.message=mlist[Vue.getLang()][16]; }
    else {Vue.message=mlist[Vue.getLang()][13];}
      Vue.setMsg(Vue.message, 5);  // setMsg: show message and stay
  });

  } else { // if anyUpdate
    Vue.setMsg(mlist[Vue.getLang()][9], 5); //資料沒變更 
  }
}

function getUserInfo(Vue) {
  let user = JSON.parse(localStorage.getItem("user")) || Vue.$store.getters.user || {};   
  let PURL = localStorage.getItem("server") || process.env.SERVER;
  let url1 = PURL + '/api/v1/db/query/user_info';
  let body = {
		"user": Vue.uname,
		"password": ''
	};
  if (user && user.name) {
      Vue.email = user.data.email;
      Vue.uitimezone = user.data.uitimezone;
      Vue.mobile         = ('mobile' in user.data) ? user.data["mobile"] : "";
      Vue.line           = ('line' in user.data) ? user.data["line"] : "";
      Vue.wechat         = ('wechat' in user.data) ? user.data["wechat"] : "";
      Vue.whatsapp       =('whatsapp' in user.data) ? user.data["whatsapp"] : "";
      console.log("Profile -- get user_info from localstorage - ", Vue.uname);
  } else {

  let p1 = Vue.$http.post(url1, body);
	Promise.all([p1]).then(([r1]) => {
		if ((r1.status === 200 || r1.status === 204)) {
        console.log("Profile -- get user info - ", Vue.uname);
      Vue.uitimezone     = r1.data["uitimezone"];
      Vue.email          = ('email' in r1.data) ? r1.data["email"] : "";
      Vue.mobile         = ('mobile' in r1.data) ? r1.data["mobile"] : "";
      Vue.line           = ('line' in r1.data) ? r1.data["line"] : "";
      Vue.wechat         = ('wechat' in r1.data) ? r1.data["wechat"] : "";
      Vue.whatsapp       =('whatsapp' in r1.data) ? r1.data["whatsapp"] : "";
      console.log("Profile -- get user_info from server - ", Vue.uname);    
      }
    }, reason => {
      console.log('Error: ', reason);
      Vue.setMsg_logout(mlist[Vue.getLang()][13], 1);  // setMsg_logout: show message and logout
      
    });

  } // if user && user.name
      Vue.uitimezone_new =Vue.uitimezone;     
      Vue.email_new      =Vue.email     ;     
      Vue.mobile_new     =Vue.mobile    ;     
      Vue.line_new       =Vue.line      ;     
      Vue.wechat_new     =Vue.wechat    ;     
      Vue.whatsapp_new   =Vue.whatsapp  ;     
    }

function acountDel(Vue) {
      let delAcountPass ="";
      delAcountPass= prompt(mlist[Vue.getLang()][17], "");
      if (delAcountPass != null) { 
        let PURL = localStorage.getItem("server") || process.env.SERVER;
        let url1 = PURL + '/api/v1/KH/delete-account';
        let body = {
          "user": Vue.uname,
          "password": delAcountPass
        };
        let p1 = Vue.$http.post(url1, body);
          Promise.all([p1]).then(([r1]) => {
            if ((r1.status === 200 || r1.status === 204)) {
              //console.log('delete acount: ', body.user, r1);
              Vue.setMsg_logout(Vue.message=mlist[Vue.getLang()][18], 5); 
            } 
          }, reason => {
            let rea=JSON.stringify(reason) ; 
            console.log('server error: ', reason.body);
            if (rea.match(/wrong password/gi)) {
                  Vue.message=mlist[Vue.getLang()][16]; }
            else {Vue.message=mlist[Vue.getLang()][13];}
            Vue.setMsg(Vue.message, 5);  // setMsg_logout: show message and logout
            });
      } // delAcountPass != null, =null is cancel button in prompt dialog box
    }

function DelDevice(Vue) {
  let user = JSON.parse(localStorage.getItem("user")) || Vue.$store.getters.user || {};  
  let PURL = localStorage.getItem("server") || process.env.SERVER;
  let url = PURL + '/api/v1/KH/delete-user-device';
  let body = {
    "user": Vue.uname,
    "password": Vue.currentPassword,
    "serial": Vue.newSerial,
    "passcode": Vue.newPassCode,
  };
  //console.log('DelDevice', body);
  if (Vue.newSerial === null || Vue.newSerial === "") {
    Vue.message = mlist[Vue.getLang()][24];
    Vue.setMsg(Vue.message, 5); return;// show message no input
  }
  let p1 = Vue.$http.post(url, body);
  Promise.all([p1]).then(([r1]) => {
    //console.log("change: ", r1);
    console.log("Success to delete device");
    ////////// delete device in localstorage user.data.devices //////
    let array=[];
    for(let i = 0; i < user.data.devices.length; i++) {
        if (user.data.devices[i] !== Vue.newSerial) {
           array.push(user.data.devices[i]);}}
    user.data.devices = array; 
    localStorage.setItem('user', JSON.stringify(user));

    Vue.setMsg_mykh(mlist[Vue.getLang()][21] + Vue.newSerial, 5); // show message and return to my-kh to reload new device config
  }, reason => {
      let rea=JSON.stringify(reason) ; 
      console.log('server error: ', reason.body);
      if (rea.match(/device not found/gi)) {
            Vue.message=mlist[Vue.getLang()][25];}
      if (rea.match(/not owned/gi)) {
            Vue.message=mlist[Vue.getLang()][20];}
      if (rea.match(/no user own/gi)) {
            Vue.message=mlist[Vue.getLang()][27];}
      if (rea.match(/delete account/gi)) {
            Vue.message=mlist[Vue.getLang()][22];}
      if (rea.match(/wrong passcode/gi)) {
            Vue.message=mlist[Vue.getLang()][15];}
     
      Vue.setMsg(Vue.message, 5); // show message only
  }); 
}

function ResetDevice(Vue) {
  let PURL = localStorage.getItem("server") || process.env.SERVER;
  let url = PURL + '/api/v1/KH/factory-reset-device';
  let body = {
    "user": Vue.uname,
    "password": Vue.currentPassword,
    "serial": Vue.newSerial,
    "passcode": Vue.newPassCode,
  };
  //console.log('ResetDevice', body);
  if (Vue.newSerial === null || Vue.newSerial === "") {
    Vue.message = mlist[Vue.getLang()][24];
    Vue.setMsg(Vue.message, 5); return;// show message and logout to reload new device from login
  }
  let p1 = Vue.$http.post(url, body);
  Promise.all([p1]).then(([r1]) => {
    //console.log("change: ", r1);
    console.log('factory reset device and delete all data');
    //Vue.setMsg_logout(mlist[Vue.getLang()][21] + Vue.newSerial, 5); // show message and logout to reload new device from login
  }, reason => {
      let rea=JSON.stringify(reason) ; 
      console.log('server error: ', reason.body);
      if (rea.match(/device not found/gi)) {
            Vue.message=mlist[Vue.getLang()][25];}
      if (rea.match(/not owned/gi)) {
            Vue.message=mlist[Vue.getLang()][20];}
      Vue.setMsg(Vue.message, 5); // show message only
  });
}
function ResetDevice_G(Vue) {     // factory reset a group of devices 
  let Serial_Pass_array = Vue.newSerial_G.split('\n');  // get 'KH1-00-00123, abcd' string
  for(let i = 0; i < Serial_Pass_array.length; i++) {
      Vue.newSerial = Serial_Pass_array[i].split('\t')[0];
      Vue.newPassCode = Serial_Pass_array[i].split('\t')[1]; 
  
      console.log('factory reset device and delete all data ', Vue.newSerial);
      ResetDevice(Vue);
  } // for i
}
function DelDbDevice(Vue) {
  let PURL = process.env.SERVER;
  let url = PURL + '/api/v1/KH/delete-db-device';
  let body = {
    "user": Vue.uname,
    "password": Vue.currentPassword,
    "serial": Vue.newSerial,
    "passcode": Vue.newPassCode,
  };
  //console.log('DelDevice', body);
  if (Vue.newSerial === null || Vue.newSerial === "") {
    Vue.message = mlist[Vue.getLang()][24];
    Vue.setMsg(Vue.message, 5); return;// show message and logout to reload new device from login
  }
  let p1 = Vue.$http.post(url, body);
  Promise.all([p1]).then(([r1]) => {
    //console.log("change: ", r1);
    console.log("Success to delete device in aqdev DB");
    Vue.setMsg(mlist[Vue.getLang()][21] + Vue.newSerial, 5); // show message and logout to reload new device from login
  }, reason => {
      let rea=JSON.stringify(reason) ;   
      console.log('server error: ', reason.body);
      if (rea.match(/device not found/gi)) {
            Vue.message=mlist[Vue.getLang()][25];}
      if (rea.match(/owned/gi)) {
            Vue.message=mlist[Vue.getLang()][26];}
      if (rea.match(/wrong passcode/gi)) {
            Vue.message=mlist[Vue.getLang()][15];}
     
      Vue.setMsg(Vue.message, 5); // show message only
  }); 
}
function DelDbDevice_G(Vue) {     // reset a group of device 
  let Serial_Pass_array = Vue.newSerial_G.split('\n');  // get 'KH1-00-00123, abcd' string
  for(let i = 0; i < Serial_Pass_array.length; i++) {
      Vue.newSerial = Serial_Pass_array[i].split('\t')[0];
      Vue.newPassCode = Serial_Pass_array[i].split('\t')[1]; 
  
      console.log('Delete Serial ', Vue.newSerial,  'Pass ', Vue.newPassCode );
      DelDbDevice(Vue);
  } // for i
}
function ResetPasscode(Vue) {
  let PURL = process.env.SERVER;
  let url = PURL + '/api/v1/KH/reset_by_admin';
  let body = {
    "user": Vue.uname,
    "password": Vue.currentPassword,
    "serial": Vue.newSerial
  };
  
  if (Vue.newSerial === null || Vue.newSerial === "") {
    Vue.message = mlist[Vue.getLang()][24];
    Vue.setMsg(Vue.message, 5); return;// show message and logout to reload new device from login
  }
  let p1 = Vue.$http.post(url, body);
  Promise.all([p1]).then(([r1]) => {
    //console.log("change: ", r1);
    console.log("Success to reset passcode", Vue.newSerial);
    Vue.message = mlist[Vue.getLang()][28] + Vue.newSerial;
    Vue.setMsg(Vue.message, 5); // show message and logout to reload new device from login
  }, reason => {
      let rea=JSON.stringify(reason) ;   
      console.log('server error: ', reason.body);
      if (rea.match(/device not found/gi)) {
            Vue.message=mlist[Vue.getLang()][25];}
      Vue.setMsg(Vue.message, 5); // show message only
  });
}
function ResetPasscode_G(Vue) {     // reset a group of device 
  let Serial_Pass_array = Vue.newSerial_G.split('\n');  // get 'KH1-00-00123, abcd' string
  for(let i = 0; i < Serial_Pass_array.length; i++) {
      Vue.newSerial = Serial_Pass_array[i].split('\t')[0];
      Vue.newPassCode = Serial_Pass_array[i].split('\t')[1]; 
  
      console.log('Reset Serial ', Vue.newSerial,  'Pass ', Vue.newPassCode );
      ResetPasscode(Vue);
  } // for i
}
function ResetPasscode_test(Vue) {
  let PURL = process.env.SERVER;
  let url = PURL + '/api/v1/KH/reset_by_admin_testmode';
  let body = {
    "user": Vue.uname,
    "password": Vue.currentPassword,
    "serial": Vue.newSerial
  };
  
  if (Vue.newSerial === null || Vue.newSerial === "") {
    Vue.message = mlist[Vue.getLang()][24];
    Vue.setMsg(Vue.message, 5); return;// show message and logout to reload new device from login
  }
  let p1 = Vue.$http.post(url, body);
  Promise.all([p1]).then(([r1]) => {
    //console.log("change: ", r1);
    console.log("Success to reset passcode and set testmode", Vue.newSerial);
    Vue.message = mlist[Vue.getLang()][28] + Vue.newSerial;
    Vue.setMsg(Vue.message, 5); // show message and logout to reload new device from login
  }, reason => {
      let rea=JSON.stringify(reason) ;   
      console.log('server error: ', reason.body);
      if (rea.match(/device not found/gi)) {
            Vue.message=mlist[Vue.getLang()][25];}
      Vue.setMsg(Vue.message, 5); // show message only
  });
}
function ResetPasscode_test_G(Vue) {     // reset a group of device 
  let Serial_Pass_array = Vue.newSerial_G.split('\n');  // get 'KH1-00-00123, abcd' string
  for(let i = 0; i < Serial_Pass_array.length; i++) {
      Vue.newSerial = Serial_Pass_array[i].split('\t')[0];
      Vue.newPassCode = Serial_Pass_array[i].split('\t')[1]; 
  
      console.log('Reset testmode Serial ', Vue.newSerial,  'Pass ', Vue.newPassCode );
      ResetPasscode_test(Vue);
  } // for i
}

function Set_version(Vue) {
  let PURL = process.env.SERVER;
  let url = PURL + '/api/v1/KH/update_ver';
  let body = {
    "user": Vue.uname,
    "password": Vue.currentPassword,
    "serial": Vue.newSerial,
    "version": Vue.newVer
  };
  
  if (Vue.newSerial === null || Vue.newSerial === "") {
    Vue.message = mlist[Vue.getLang()][24];
    Vue.setMsg(Vue.message, 5); return;// show message
  }
  let p1 = Vue.$http.post(url, body);
  Promise.all([p1]).then(([r1]) => {
    //console.log("change: ", r1);
    console.log("Success to set update version", Vue.newSerial, "ver ", Vue.newVer);
    Vue.message = mlist[Vue.getLang()][28] + Vue.newSerial + "ver " + Vue.newVer;
    Vue.setMsg(Vue.message, 5); // show message
  }, reason => {
      let rea=JSON.stringify(reason) ;   
      console.log('server error: ', reason.body);
      if (rea.match(/device not found/gi)) {
            Vue.message=mlist[Vue.getLang()][25];}
      Vue.setMsg(Vue.message, 5); // show message only
  });
}
function Set_version_G(Vue) {     // reset a group of device 
  let Serial_Pass_array = Vue.newSerial_G.split('\n');  // get 'KH1-00-00123, abcd' string
  for(let i = 0; i < Serial_Pass_array.length; i++) {
      Vue.newSerial = Serial_Pass_array[i].split('\t')[0];
      Vue.newPassCode = Serial_Pass_array[i].split('\t')[1]; 
      Vue.newVer = Serial_Pass_array[i].split('\t')[2]; 
      console.log('Set update version for Serial ', Vue.newSerial,  'Pass ', Vue.newPassCode, 'Ver ', Vue.newVer );
      Set_version(Vue);
  } // for i
}

export default {
  data: () => {
    return {
      uname:"",
      disabled: false, // button is enabled by default
      message: "",
      msglist: mlist,
      currentPassword: "",
      newPassword: "",
      newPassword1:"",
      newSerial:"",
      newDevname:"",
      newSerial_G:"",
      newPassCode:"",
      newVer:"",
      uitimezone:"",
      email:"",
      mobile:"",
      line:"",
      wechat:"",
      whatsapp:"",
      uitimezone_new:"",
      email_new:"",
      mobile_new:"",
      line_new:"",
      wechat_new:"",
      whatsapp_new:"",
      time_out:"",
      //userS: localStorage.getItem('user')
    }
  },
  destroyed: function () {
    //console.log('Profile destroy step');
    //clearInterval(this.time_out);
    clearTimeout(this.time_out);
  },
  computed: {
    alertObject: function() {
        if (this.message) {
            return {"alert": true, "alert-info": true, "alert-warning":true, "alert-danger": false};  // alert-danger 紅色背景 alert-waring 黃色背景
        } else if (this.message.match('error')) {
            return {"alert": true, "alert-danger": true, "alert-info": false};
        } else {
            return {"alert": false, "alert-info": false, "alert-danger": false};
        }
    },

  },
  methods: {
    fillUserInfo: function() {
     getUserInfo(this);
    },
    getLang: function () {
		  //console.log("lang: ", mapLang(), this.$route.params);
			  if (this.$route.params.language) {
			  return this.$route.params.language;
		  } else {
			  return mapLang();
		  }
    },
    
    setMsg_mykh: function (message, timer) {   // show message for timer sec and to my-kh
        this.message = message;
        // set time in ms
        setTimeout( () => {
            this.message = "";
            this.enable();
            this.$router.push({ name: 'my-kh', params: { language: this.$route.params.language } })
        }, timer*1000);
        
    },
    setMsg_logout: function (message, timer) {  // show message for timer sec and logout
        this.message = message;
        // set time in ms
        
        setTimeout( () => {
            this.message = "";
            this.enable();
            ////// to complete logout and show login page need this 3 items
            this.$store.dispatch("setUser", {name: '', token: ''});
            this.$auth.destroyToken();
            this.$router.push({ name: 'entry', params: { language: this.$route.params.language } })
        }, timer*1000);
        
    },
    setMsg: function (message, timer) {   // show message for timer sec 
        this.message = message;
        // set time in ms
        setTimeout( () => {
            this.message = "";
            this.enable();
        }, timer*1000);
        
    },
    addDevice: function() {
      console.log("add new device for: ", this.uname);
      this.disable();
      RegDevice(this); 
    },
    updDevname: function() {
      console.log("update device name for: ", this.uname);
      this.disable();
      Set_Dev_name(this); 
    },
    insertDevice: function() {
      //console.log("Insert new device: ", this.uname);
      this.disable();
      InsDevice(this); 
    },
     insertDevice_G: function() {    // insert multiple device into DB
      //console.log("Insert new device: ", this.uname);
      this.disable();
      InsDevice_G(this); 
    },
    delDevice: function() {      // delete device of an user
      if (confirm(this.msglist[this.$auth.getLang()][23])) {
        this.disable();
        console.log("Reset device parameter and delete all data");
        ResetDevice(this);
        console.log("delete device for: ", this.uname);
        DelDevice(this); 
        
      } else {
        this.disable();
        console.log("delete device for: ", this.uname);
        DelDevice(this);
      }
      
       
    },
     delDbDevice: function() {
      if (confirm(this.msglist[this.$auth.getLang()][23])) {
        console.log("Delete device parameter and data");
        this.disable();
        DelDbDevice(this);  
      }
    },
    delDbDevice_G: function() {
      if (confirm(this.msglist[this.$auth.getLang()][23])) {
        console.log("Delete Group of device parameter and data");
        this.disable();
        DelDbDevice_G(this);  
      }
    },
    resetPcode: function() {
      console.log("Reset device passcode");
        this.disable();
        ResetPasscode(this);
    },
    resetPcode_G: function() {
      console.log("Reset Group of device passcode");
        this.disable();
        ResetPasscode_G(this);
    },
    resetPcode_test: function() {
      console.log("Reset device passcode and set testmode");
        this.disable();
        ResetPasscode_test(this);
    },
    resetPcode_test_G: function() {
      console.log("Reset Group of device passcode and set testmode");
        this.disable();
        ResetPasscode_test_G(this);
    },
    update_ver_G: function() {
      console.log("Set Group of update version");
        this.disable();
        Set_version_G(this);
    },
    resetDevice: function() {
      if (confirm(this.msglist[this.$auth.getLang()][23])) {
      console.log("Reset device and delete all data");
        this.disable();
        ResetDevice(this);
      }
    },
    resetDevice_G: function() {
      console.log("Reset Group of device and delete all data");
        this.disable();
        ResetDevice_G(this);
    },
    applyChange: function() {
      console.log("change user info: ", this.uname);
      this.disable();
      changeInfo(this);
    },
    delMail: function() {   // manual delete email of any user due to fail to deliver email
      console.log("delete email: ", this.email_new);
      this.disable();
      deletemail(this);
    },
    delAcount: function() {
      console.log("delete user account: ", this.uname);
      acountDel(this);
        //this.$store.dispatch("setUser", {name: '', token: ''});
        // this.$auth.destroyToken();
        //console.log('logout: check: destroy', this.$auth.loggedIn());
    },
    disable: function() { this.disabled = true; },
    enable: function() { this.disabled = false; },
    loggingOut: function() {
        //console.log('logout: check: ', this.$auth.loggedIn());
        this.$store.dispatch("setUser", {name: '', token: ''});
        this.$auth.destroyToken();
        //console.log('logout: check: destroy', this.$auth.loggedIn());
      }
  },
  mounted() {
    //console.log('mounted: ', this);
	  //console.log('this.user.name=', this.user.name);
	  //this.serial = this.user.data.devices[0]
    //this.uname = this.user.name
    let user = JSON.parse(localStorage.getItem("user")) || Vue.$store.getters.user || {}; 
    this.uname= user.name;
	  //
    if (this.$auth.loggedIn()) {
			this.time_out=setTimeout( () => {     // return to my-kh after 5 min
            this.$router.push({ name: 'my-kh', params: { language: this.$route.params.language } })
        }, 600*1000);
      //this.poller = setTimeout(this.fillUserInfo(), 60 * 60 * 1000);
      this.fillUserInfo();
    } else {
      this.$auth.destroyToken();
      this.$router.push({ name: 'entry', params: { language: this.$route.params.language } })
    }
  },

}
</script>



// WEBPACK FOOTER //
// Profile.vue?505dc420